import React, { useState } from 'react';
import { SearchbarHeader } from './searchHeaderStyles';
import Searchbar from './Searchbar';
import UserAvatar from './UserAvatar';
import { IonItem, IonList } from '@ionic/react';
import { v4 } from 'uuid';

type SearchHeaderProps = {
	showAvatar: boolean;
};

const SearchHeader: React.FC<SearchHeaderProps> = ({ showAvatar }) => {
	return (
		<>
			{showAvatar && <UserAvatar />}

			<SearchbarHeader>
				<Searchbar />
			</SearchbarHeader>

			{/* {autocompleteVisible && (
				<div className="queryText">
					<IonList>
						{results.map((result) => (
							<IonItem key={v4()}>{result}</IonItem>
						))}
					</IonList>
				</div>
			)} */}
		</>
	);
};

export default SearchHeader;
